/* The one notice for a lookup that failed, between the section tabs and the screen's body. It is a
   flex child of the shell's column, so it takes the height of its words and nothing when there are none. */
.strip {
  flex: 0 0 auto;
  padding: 0 var(--gap);
}
